<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
<!--          <date-range v-model:start-time="searchInfo.startPlan" v-model:end-time="searchInfo.endPlan"/>-->
          <el-input v-model="searchInfo.projectName" placeholder="请输入查询关键字" @keydown.enter="resetSearch">
            <template #prefix>项目名称</template>
          </el-input>
          <employee-select v-model="searchInfo.leader">
            <template #prefix>负责人</template>
          </employee-select>
          <el-select v-model="searchInfo.status" placeholder="请选择项目状态" clearable>
            <template #prefix>项目状态</template>
            <el-option label="未开始" :value="0"/>
            <el-option label="进行中" :value="1"/>
            <el-option label="已完成" :value="100"/>
          </el-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasPerm="project:list:save" el-type="success" @click="$router.push(`/project/list/detail`)">新建</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="projectList">
          <yq-table-column  label="项目名称" prop="projectName" min-width="180rem"/>
          <yq-table-column label="所属部门" prop="departCode">
            <template v-slot="{row}">
              <depart-select v-model="row.departCode" :data="departList" :disabled="true"/>
            </template>
          </yq-table-column>
          <yq-table-column label="负责人" prop="leaderName"/>
          <yq-table-column label="计划时间" prop="planTime">
            <template #default="{row}">
              <date-range v-model:start-time="row.planStartTime" v-model:end-time="row.planEndTime" :show-short-cut="false" :disabled="true"/>
            </template>
          </yq-table-column>
          <yq-table-column label="工地数量" prop="siteCount"/>
          <yq-table-column label="项目状态" prop="status">
            <template #default="{row}">
              <el-tag v-if="row.status === 0" type="info">未开始</el-tag>
              <el-tag v-if="row.status === 1" type="success">进行中</el-tag>
              <el-tag v-if="row.status === 100" type="warning">已完成</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button hasPerm="project:list:save" @click="$router.push(`/project/list/detail?id=${row.id}`)">编辑</table-button>
                <table-button hasPerm="project:list:remove" el-type="danger" message="是否确认删除数据" @click="deleteRow(row.id)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import DateRange from "@/components/h5/date/YqDateRange.vue";
import projectApi from "@/api/dz-luqiao/luqiaoProjectApi";
import commonApi from "@/api/commonApi";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    DateRange, DepartSelect, YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, EmployeeSelect
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      departList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      // 查询部门
      commonApi.queryDepartList().then(list => this.departList = list);
      this.resetSearch();
    }

  },
  methods: {
    async queryList() {
      const {records, totalCount} = await projectApi.list(this.searchInfo)
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    async deleteRow(id){
      await projectApi.delete(id)
      this.resetSearch()
    }
  }
};
</script>

<style lang="scss" scoped>
</style>